import React from 'react';
import { LangBlock } from '../../global';

type Props = {
    page: number;
    totalPages: number;
    total: number;
    limit: number;
    limitOptions?: number[];
    onPageChange: (page: number) => void;
    onLimitChange: (limit: number) => void;
};

const pageRange = (page: number, totalPages: number, maxButtons = 5) => {
    const half = Math.floor(maxButtons / 2);
    let start = Math.max(1, page - half);
    let end = Math.min(totalPages, start + maxButtons - 1);

    start = Math.max(1, end - maxButtons + 1);

    const pages: number[] = [];

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return pages;
};

export const AdminPagination = ({
    page,
    totalPages,
    total,
    limit,
    limitOptions = [10, 30, 50, 100, 500, 1000],
    onPageChange,
    onLimitChange,
}: Props) => {
    const [, , LangString] = LangBlock();
    const pages = pageRange(page, totalPages);
    const from = total === 0 ? 0 : (page - 1) * limit + 1;
    const to = Math.min(page * limit, total);

    return (
        <div className="admin-pagination">
            <div className="admin-pagination__info">
                {LangString('AdminPaginationInfo', from, to, total)}
            </div>

            <div className="admin-pagination__controls">
                <button
                    type="button"
                    className="admin-pagination__btn"
                    disabled={page <= 1}
                    onClick={() => onPageChange(1)}
                    aria-label={LangString('AdminPaginationFirst')}
                >
                    «
                </button>
                <button
                    type="button"
                    className="admin-pagination__btn"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                    aria-label={LangString('AdminPaginationPrev')}
                >
                    ‹
                </button>

                <div className="admin-pagination__pages">
                    {pages.map((p) => (
                        <button
                            key={p}
                            type="button"
                            className={`admin-pagination__page${p === page ? ' admin-pagination__page--active' : ''}`}
                            onClick={() => onPageChange(p)}
                        >
                            {p}
                        </button>
                    ))}
                </div>

                <button
                    type="button"
                    className="admin-pagination__btn"
                    disabled={page >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                    aria-label={LangString('AdminPaginationNext')}
                >
                    ›
                </button>
                <button
                    type="button"
                    className="admin-pagination__btn"
                    disabled={page >= totalPages}
                    onClick={() => onPageChange(totalPages)}
                    aria-label={LangString('AdminPaginationLast')}
                >
                    »
                </button>
            </div>

            <label className="admin-pagination__limit">
                <span>{LangString('AdminPerPage')}</span>
                <select
                    value={limit}
                    onChange={(e) => onLimitChange(parseInt(e.target.value, 10))}
                >
                    {limitOptions.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </label>
        </div>
    );
};
